import React, { VFC, useCallback, useMemo } from 'react';

import { RadioButton } from '@rbilabs/components-library';

import { IItemOptionModifier } from '@rbi-ctg/menu';
import { ListItemGroup } from 'components/list-item-group';

import { ModifierListItem } from './modifier-list-item';
import { ModifierOptionsContainer } from './modifier.styled';
import { IModifierTypeUIProps } from './types';
import { getSingleSelectedOption, transformSelectedOptionToSelections } from './utils';

export const ModifierSingleChoice: VFC<IModifierTypeUIProps> = ({
  modifier,
  selections,
  onSelectionsChange,
}) => {
  const selectedOption = useMemo(() => getSingleSelectedOption(selections), [selections]);
  const handleListItemClick = useCallback(
    (option: IItemOptionModifier) => {
      onSelectionsChange(transformSelectedOptionToSelections(option));
    },
    [onSelectionsChange]
  );
  return (
    <ModifierOptionsContainer data-testid="modifier-single-choice">
      <ListItemGroup
        items={modifier.options.map(option => (
          <ModifierListItem
            key={option._key}
            isListItemClickable
            onListItemClick={() => handleListItemClick(option)}
            content={option}
            controls={
              <RadioButton
                data-testid="modifier-single-choice-radio"
                label=""
                checked={option._key === selectedOption._key}
              />
            }
          />
        ))}
      />
    </ModifierOptionsContainer>
  );
};
